function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Image, Heading, ResponsiveContext } from 'grommet';
import { LinkPrevious } from 'grommet-icons';
import Logo from 'assets/logo.png';
import DarkLogo from 'assets/logo_dark.png';
import Dashboard from 'assets/dashboard.png';
const DefaultSideContent = ({
  history
}) => /*#__PURE__*/React.createElement(Box, {
  justify: "between",
  height: "100%",
  gap: "large"
}, /*#__PURE__*/React.createElement(Box, {
  flex: {
    shrink: 0
  },
  onClick: history.goBack,
  alignSelf: "start"
}, /*#__PURE__*/React.createElement(LinkPrevious, {
  color: "white"
})), /*#__PURE__*/React.createElement(Box, {
  alignSelf: "center",
  flex: {
    shrink: 0
  }
}, /*#__PURE__*/React.createElement(Image, {
  src: Dashboard,
  fit: "contain"
}), /*#__PURE__*/React.createElement(Box, null)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
  level: 4,
  size: "large",
  color: "white"
}, "THE NEW VERSION IS HERE!"), /*#__PURE__*/React.createElement(Heading, {
  level: 5,
  color: "white",
  size: "large"
}, "Faster, more powerful and built for teams")));
const SplitLayout = ({
  mainContent,
  sideContent,
  bannerPadding,
  showLogo,
  sideWidth,
  sideProps,
  mainProps,
  logoWidth
}) => {
  const history = useHistory();
  const size = useContext(ResponsiveContext);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row-responsive",
    fill: true
  }, size !== 'small' && /*#__PURE__*/React.createElement(Box, _extends({
    background: "brand",
    basis: `${sideWidth}%`,
    justify: sideContent ? 'center' : undefined,
    pad: bannerPadding,
    fill: true
  }, sideProps), sideContent ? sideContent : /*#__PURE__*/React.createElement(DefaultSideContent, {
    history: history
  })), /*#__PURE__*/React.createElement(Box, _extends({
    basis: size !== 'small' ? `${100 - sideWidth}%` : '100%',
    pad: {
      horizontal: '10%'
    },
    overflow: {
      vertical: 'auto'
    }
  }, mainProps), showLogo && /*#__PURE__*/React.createElement(Box, {
    width: logoWidth,
    margin: {
      vertical: 'medium'
    },
    flex: {
      shrink: 0
    }
  }, /*#__PURE__*/React.createElement(Image, {
    src: DarkLogo || Logo,
    fit: "contain"
  })), mainContent));
};
SplitLayout.defaultProps = {
  bannerPadding: 'large',
  showLogo: true,
  sideWidth: '40',
  sideProps: {},
  mainProps: {},
  logoWidth: 'small'
};
SplitLayout.propTypes = {
  bannerPadding: PropTypes.string,
  showLogo: PropTypes.bool,
  sideWidth: PropTypes.string,
  sideProps: PropTypes.object,
  mainProps: PropTypes.object,
  logoWidth: PropTypes.string,
  mainContent: PropTypes.object,
  sideContent: PropTypes.object
};
DefaultSideContent.propTypes = {
  history: PropTypes.object
};
export default SplitLayout;